<template>
  <reusable-dialog v-model="isVisibleDialog">
    <h3
      slot="title"
      v-text="$t('payment.auto.redirection.alert.title')"
    ></h3>

    <div :class="$style.content">
      <p
        v-m-b="20"
        v-text="$t('payment.auto.redirection.alert.message.primary')"
      ></p>
      <p v-text="$t('payment.auto.redirection.alert.message.secondary')"></p>
    </div>

    <div slot="footer" :class="$style.footer">
      <simple-button
        variant="primary"
        @click="isVisibleDialog = false"
      >
        {{ $t('dialog.button.clear') }}
      </simple-button>
    </div>
  </reusable-dialog>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'PaymentAutoRedirectionAlert',
  components: {
    SimpleButton,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_ALERT_TO_PAYMENT_AUTO_REDIRECTION', this.initialize);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_SHOW_ALERT_TO_PAYMENT_AUTO_REDIRECTION', this.initialize);
  },
  data() {
    return {
      isVisibleDialog: false,
    };
  },
  methods: {
    initialize() {
      this.isVisibleDialog = true;
    },
  },
};
</script>

<style lang="sass" module>
  .content
    color: #fff
    opacity: .75

  .footer
    width: 100%
    margin: 0 auto

    +respond-to('medium')
      width: 230px
</style>
